<div>
  <div class="div__text">
    <h1>
      <strong >{{ 'PAGE_NOT_FOUND' | translate | capitalizeFirst }}</strong>
    </h1>
  </div>
</div>
